module.exports = __webpack_public_path__ + "assets/img/ambition-4.56081a5f.svg";